import { render, staticRenderFns } from "./EdifactMessage.vue?vue&type=template&id=23a26be0&"
import script from "./EdifactMessage.vue?vue&type=script&lang=js&"
export * from "./EdifactMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports